import { HTMLAttributes, ReactNode } from 'react';
import classnames from 'src/util/classnames';

interface ButtonGroupProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'lg';
  vertical?: boolean;
  children?: ReactNode;
}

export function ButtonGroup({ size, vertical, className, children, ...props }: ButtonGroupProps) {
  return (
    <div role="group" className={classnames(vertical ? 'btn-group-vertical' : 'btn-group', size && `btn-group-${size}`, className)} {...props}>
      {children}
    </div>
  );
}
